export default __webpack_public_path__ + "static/media/mgit.26ce77d0.jpeg";